module.exports = __webpack_public_path__ + "img/avatar1.d85e9aef.png";